import { Injectable } from '@angular/core';
import { IBeverage, IBeverageVM } from '../../models/beverage';
import { compareAsc } from 'date-fns';
@Injectable({
  providedIn: 'root'
})
export class SortService {

  constructor() { }



  //#region Beverage
  static sortBeverageItems(items: IBeverageVM[], sortBy: string): IBeverageVM[] {
    if (sortBy == 'can-bottle') {
      items.sort(this.compareBeverageCansAndBottlesCount);
    } else if (sortBy == 'favorite') {
      items.sort(this.compareFavorite);
    } else if (sortBy == 'name') {
      items.sort(this.compareBeverageName);
    } else if (sortBy == 'kegs') {
      items.sort(this.compareBeverageKegsCount);
    } else if (sortBy == 'newest') {
      items.sort(this.compareBeverageCreateDate);
    } else if (sortBy == 'best-date') {
      items.sort(this.compareBeverageBestBeforeDate);
    } else if (sortBy == 'rating') {
      items.sort(this.compareBeverageRating);
    } else if (sortBy == 'order') {
      items.sort(this.compareBeverageOrder);
    }

    return items;
  }

  private static compareBeverageCansAndBottlesCount(a: IBeverageVM, b: IBeverageVM) {
    // Use `Number(x) || 0` so an undefined / null / non-numeric count
    // is treated as 0. `+undefined` is NaN, and NaN poisons the sum so the
    // comparison returns 0 and the list ends up unsorted.
    const sumCounts = (item: { count?: number | string | null }) => Number(item?.count) || 0;
    const bandA =
      (a.cans?.reduce((sum, c) => sum + sumCounts(c), 0) ?? 0) +
      (a.bottles?.reduce((sum, b) => sum + sumCounts(b), 0) ?? 0);
    const bandB =
      (b.cans?.reduce((sum, c) => sum + sumCounts(c), 0) ?? 0) +
      (b.bottles?.reduce((sum, b) => sum + sumCounts(b), 0) ?? 0);

    // Descending: highest count first.
    if (bandA > bandB) return -1;
    if (bandA < bandB) return 1;
    return 0;
  }

  private static compareFavorite(a: IBeverage, b: IBeverage) {
    // Use toUpperCase() to ignore character casing
    const bandA = a.favorite;
    const bandB = b.favorite;

    // true values first
    return (bandA === bandB) ? 0 : bandA ? -1 : 1;

    // false values first
    // return (bandA === bandB)? 0 : bandA? 1 : -1;
  }

  private static compareBeverageName(a: IBeverage, b: IBeverage) {
    // Use toUpperCase() to ignore character casing
    const bandA = a.name.toLowerCase();
    const bandB = b.name.toLowerCase();

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }

    return comparison;
  }

  private static compareBeverageKegsCount(a: IBeverageVM, b: IBeverageVM) {
    // Compare the number of kegs, not the array reference itself.
    // The previous version did `bandA > bandB` on the arrays, which
    // forces stringification and rarely produces a useful ordering.
    const bandA = a.kegs?.length ?? 0;
    const bandB = b.kegs?.length ?? 0;

    // Descending: most kegs first.
    if (bandA > bandB) return -1;
    if (bandA < bandB) return 1;
    return 0;
  }

  private static compareBeverageCreateDate(a: IBeverage, b: IBeverage) {
    // Use toUpperCase() to ignore character casing
    const bandA = a.uDate ?? '';
    const bandB = b.uDate ?? '';

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }


  private static compareBeverageBestBeforeDate(a: IBeverage, b: IBeverage) {
    // Use toUpperCase() to ignore character casing
    const bandA = a.bestBeforeDate ? new Date(a.bestBeforeDate) : new Date(8640000000000000);
    const bandB = b.bestBeforeDate ? new Date(b.bestBeforeDate) : new Date(8640000000000000);

    return compareAsc(bandA, bandB);


    // let comparison = 0;
    // if (bandA > bandB) {
    //   comparison = 1;
    // } else if (bandA < bandB) {
    //   comparison = -1;
    // }
    // return comparison;
  }

  private static compareBeverageRating(a: IBeverage, b: IBeverage) {
    const bandA = a.rating ?? 0;
    const bandB = b.rating ?? 0;

    let comparison = 0;
    if (bandA > bandB) {
      comparison = -1; // Descending: higher rating comes first
    } else if (bandA < bandB) {
      comparison = 1;
    }
    return comparison;
  }


  private static compareBeverageOrder(a: IBeverage, b: IBeverage) {
    // Use toUpperCase() to ignore character casing
    const bandA = +(a.order ?? 0);
    const bandB = +(b.order ?? 0);

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  //#endregion



}
